var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _ellipse, _ellipse2, _ellipse3, _rect0, _rect1, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCommentsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 98,
    viewBox: "0 0 95 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.9455,
    cy: 48.0077,
    r: 42.8552,
    fill: "url(#paint0_linear_362_2449)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_362_2449)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.5503,
    y: 27.5187,
    width: 52.8,
    height: 39.0464,
    rx: 2.07059,
    fill: "#F3F4F6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.2092,
    y: 37.0169,
    width: 43.4824,
    height: 4.22123,
    rx: 1.55294,
    fill: "#E8EAED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2092,
    y: 37.0169,
    width: 43.4824,
    height: 4.22123,
    rx: 1.55294,
    stroke: "#687080"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2092,
    y: 46.5141,
    width: 43.4824,
    height: 4.22123,
    rx: 1.55294,
    fill: "#E8EAED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2092,
    y: 46.5141,
    width: 43.4824,
    height: 4.22123,
    rx: 1.55294,
    stroke: "#687080"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2092,
    y: 56.0122,
    width: 43.4824,
    height: 4.22123,
    rx: 1.55294,
    fill: "#E8EAED"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2092,
    y: 56.0122,
    width: 43.4824,
    height: 4.22123,
    rx: 1.55294,
    stroke: "#687080"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2092,
    y: 34.5538,
    width: 15.0118,
    height: 1.40708,
    rx: 0.703538,
    fill: "#D1D5DB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2092,
    y: 44.0519,
    width: 15.0118,
    height: 1.40708,
    rx: 0.703538,
    fill: "#D1D5DB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2092,
    y: 53.5501,
    width: 15.0118,
    height: 1.40708,
    rx: 0.703538,
    fill: "#D1D5DB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.5314,
    cy: 20.5627,
    rx: 1.03529,
    ry: 0.703538,
    fill: "#F9FAFB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.6373,
    cy: 20.5627,
    rx: 1.03529,
    ry: 0.703538,
    fill: "#2464E4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.7431,
    cy: 20.5627,
    rx: 1.03529,
    ry: 0.703538,
    fill: "#F9FAFB"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4607,
    y: 70.8054,
    width: 26.7845,
    height: 26.7845,
    rx: 13.3922,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_362_2449",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 70,
    width: 28,
    height: 28
  }, _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4607,
    y: 70.8054,
    width: 26.7845,
    height: 26.7845,
    fill: "#6D6E71"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_362_2449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8529 89.9172C46.2063 89.9172 46.5039 89.7963 46.7457 89.5545C46.9875 89.3127 47.1084 89.0151 47.1084 88.6617V85.4532H50.3449C50.6983 85.4532 50.9911 85.3323 51.2232 85.0905C51.4561 84.8487 51.5725 84.5511 51.5725 84.1976C51.5725 83.8442 51.4516 83.5466 51.2098 83.3048C50.968 83.063 50.6704 82.9421 50.317 82.9421H47.1084V79.7057C47.1084 79.3523 46.9875 79.0595 46.7457 78.8274C46.5039 78.5945 46.2063 78.478 45.8529 78.478C45.4995 78.478 45.2019 78.5989 44.9601 78.8407C44.7183 79.0826 44.5974 79.3802 44.5974 79.7336V82.9421H41.3609C41.0075 82.9421 40.7147 83.063 40.4826 83.3048C40.2497 83.5466 40.1333 83.8442 40.1333 84.1976C40.1333 84.5511 40.2542 84.8487 40.496 85.0905C40.7378 85.3323 41.0354 85.4532 41.3888 85.4532H44.5974V88.6896C44.5974 89.043 44.7183 89.3358 44.9601 89.5679C45.2019 89.8008 45.4995 89.9172 45.8529 89.9172ZM45.8529 95.8879C44.2161 95.8879 42.6908 95.581 41.2772 94.9672C39.8636 94.3534 38.6315 93.5212 37.581 92.4707C36.5297 91.4194 35.6971 90.1869 35.0833 88.7733C34.4695 87.3597 34.1626 85.8345 34.1626 84.1976C34.1626 82.5608 34.4695 81.0356 35.0833 79.622C35.6971 78.2083 36.5297 76.9759 37.581 75.9246C38.6315 74.874 39.8636 74.0419 41.2772 73.4281C42.6908 72.8142 44.2161 72.5073 45.8529 72.5073C47.4897 72.5073 49.015 72.8142 50.4286 73.4281C51.8422 74.0419 53.0747 74.874 54.126 75.9246C55.1765 76.9759 56.0087 78.2083 56.6225 79.622C57.2363 81.0356 57.5432 82.5608 57.5432 84.1976C57.5432 85.8345 57.2363 87.3597 56.6225 88.7733C56.0087 90.1869 55.1765 91.4194 54.126 92.4707C53.0747 93.5212 51.8422 94.3534 50.4286 94.9672C49.015 95.581 47.4897 95.8879 45.8529 95.8879Z",
    fill: "#2464E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_362_2449",
    x: 15.4091,
    y: 23.3775,
    width: 61.0824,
    height: 47.3287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.03529,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_362_2449"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.55294
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.497535 0 0 0 0 0.566854 0 0 0 0 0.670833 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_362_2449"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_362_2449",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_362_2449",
    x1: 45.9455,
    y1: 92.2021,
    x2: 44.8741,
    y2: -23.5068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D5DB",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCommentsIcon);
export default __webpack_public_path__ + "static/media/empty-comments-icon.40bcd1a0e63d9a6f42cc050eb7ba69b9.svg";
export { ForwardRef as ReactComponent };